<div class='producer-agency-line'>
    Your Region and Agency are &nbsp;
    <button class='agency-selector' aria-describedby="changeAgency" (click)="changeAgency()" tabindex="0">
        {{ currentRegion }} - {{ currentAgency }} - {{ currentAgencyId }}
    </button>
</div>
